import { Injectable, signal } from '@angular/core';

const STORAGE_KEY = 'frida.sidebar.collapsed';

@Injectable({
  providedIn: 'root',
})
export class SidebarStateService {
  private readonly collapsedState = signal(this.readStoredState());

  readonly collapsed = this.collapsedState.asReadonly();

  toggle(): void {
    this.setCollapsed(!this.collapsedState());
  }

  collapse(): void {
    this.setCollapsed(true);
  }

  expand(): void {
    this.setCollapsed(false);
  }

  private setCollapsed(value: boolean): void {
    this.collapsedState.set(value);

    try {
      localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    } catch {
      // Storage can be unavailable (private mode); the preference is simply not persisted.
    }
  }

  private readStoredState(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }
}
